/**
 *******************************************************************************
 * FILE: lgekor-ui/src/js/employee/MKFT-40004_1.js
 * Desc : 제휴사/계열사 복지몰 임직원 등록
 *
 * PROJ : 제휴사/계열사 복지몰
 *******************************************************************************
 *                  Modification History
 *******************************************************************************
 * CSR No.          DATE                 AUTHOR               DESCRIPTION
 *******************************************************************************
 * BTOCSITE-50880    2023/11/20        강유진             복지몰 임직원 등록 페이지
 *******************************************************************************
 **/

(function() {
    var partnerReg = {
        apiUrl: {
            searchPartnerList : '/mkt/api/partner/searchPartnerList.lgajax'
            , getPartnerPrivacy : '/mkt/api/partner/getPartnerPrivacy.lgajax'
            , sendPartnerAuthMail : '/mkt/api/partner/sendPartnerAuthMail.lgajax'
            , confirmPartnerAuth : '/mkt/api/partner/confirmPartnerAuth.lgajax'
            , registerPartner : '/mkt/api/partner/registerPartner.lgajax'
            , affFileUploadUrl : '/mkt/api/partner/affFileUpload.lgajax'
            , afcFileUploadUrl : '/mkt/api/partner/afcFileUpload.lgajax'
            , recommendValid : '/mkt/api/partner/recommendValid.lgajax'
        },
        el: {
            $container: null                  // 컨테이너
            , $partnerRegBtn : null           // 임직원 등록하기 버튼
            , $recommendConfirmBtn : null     // 추천인 코드 확인 버튼
            , $sendAuthNumberBtn : null       // 인증번호 받기
            , $confirmAuthBtn : null          // 인증번호 확인
            , $reSendAuthNumber : null        // 인증번호 재전송
            , $partnerPopupBtn : null		  // 회사명 팝업 버튼
            , $partnerSearchBtn : null		  // 회사명 팝업 검색 버튼
            , $partnerSetBtn : null		      // 회사명 팝업 확인 버튼
            , $partnerNamePop : null		  // 회사명 팝업 입력란
            , $partnerName : null             // 회사명 바닥 노출 영역
            , $empName : null				  // 임직원 이름
            , $email : null                   // Email
            , $emailDomain : null             // Email 도메인
            , $emailInput : null			  // 이메일 입력란
            , $countDown : null               // 타이머
            , $authNumberArea : null          // 인증번호 확인 영역
            , $authCompleteArea : null        // 인증 완료 영역
            , $authNumber : null			  // 인증번호 입력란
            , $email2 : null                   // Email 2
            , $emailDomain2 : null             // Email 도메인 2
            , $emailInput2 : null			  // 이메일 입력란 2
            , $countDown2 : null               // 타이머 2
            , $authNumberArea2 : null          // 인증번호 확인 영역 2
            , $authCompleteArea2 : null        // 인증 완료 영역 2
            , $authNumber2 : null			  // 인증번호 입력란 2
            , $bulletList : null              // bulletList
            , $partnerAgreement : null        // 임직원 등록 동의
            , $purchasePledge : null          // 구매동의서약서
            , $purchasePledge_popup : null    // 구매동의서약서 팝업
            , $purchaseAgreeBtn : null        // 구매동의서약서 동의버튼
            , $personalInfoAgree : null		  // 개인정보수집 이용동의 약관
            , $personalInfoAgree_popup : null  // 개인정보수집 이용동의 약관 팝업
            , $personalInfoAgreeBtn : null	  // 개인정보수집 이용동의 약관 동의버튼
            , $authEmlArea : null             // 인증영역 - 이메일
            , $authFlArea : null              // 인증영역 - 재직증명서
            , $authFlOptionArea : null        // 인증영역 - 재직증명서 선택
            , $authEmlFlArea : null           // 인증영역 - 이메일 + 사원증
            , $file01Url : null			      // 파일1 Url
            , $file01No : null			      // 파일1 번호
            , $file02Url : null			      // 파일2 Url
            , $file02No : null			      // 파일2 번호
            , $file03Url : null			      // 파일3 Url
            , $file03No : null			      // 파일3 번호
            , $file04Url : null			      // 파일4 Url
            , $file04No : null			      // 파일4 번호
            , $recommendNo : null             // 추천인 번호
            , $recommendArea : null            // 추천번호 입력 영역
        },
        data: {
            partnerAuthYn : 'N'
            , timerSeconds : 180
            , countInterval : null
            , partnerCode : ''
            , email : ''
            , partnerGrp : ''
            , checkedPartner : ''
            , reSendPartnerAuthMail : 'N'
            , setPartnerPrivacy : 'N'
            , prsinClctnYn : 'N'
            , authType : ''
            , subAuthType : 'EML'
            , recommendNo : ''
            , recommendAuth : 'N'
            , reCertifyYn : 'N'
        },
        selector: {
            container : '.container'
            , partnerRegBtn : '#partnerRegBtn'
            , recommendConfirmBtn :'#recommendConfirmBtn'
            , sendAuthNumberBtn : 'button[name=sendAuthNumberBtn]'
            , confirmAuthBtn : 'button[name=confirmAuthBtn]'
            , partnerNamePop : '#partnerNmPop'
            , partnerName : '#partnerNm'
            , empName  : '#empNm'
            , email : '#userEmail'
            , emailDomain : '#userEmailDomain'
            , emailInput : '.emailInput'
            , countDown : '#countDown'
            , authNumberArea : '#authNumber_area'
            , authCompleteArea : '#authComplete_area'
            , email2 : '#userEmail2'
            , emailDomain2 : '#userEmailDomain2'
            , emailInput2 : '.emailInput2'
            , countDown2 : '#countDown2'
            , authNumberArea2 : '#authNumber_area2'
            , authCompleteArea2 : '#authComplete_area2'
            , bulletList : '#bulletList'
            , partnerAgreement : '#partnerAgreement'
            , purchasePledge : '#purchasePledge'
            , purchasePledge_popup : '#purchasePledge_popup'
            , purchaseAgreeBtn : '#purchaseAgreeBtn'
            , personalInfoAgree : '#personalInfoAgree'
            , personalInfoAgree_popup : '#personalInfoAgree_popup'
            , personalInfoAgreeBtn : '#personalInfoAgreeBtn'
            , reSendAuthNumber : 'a[name=reSendAuthNumber]'
            , authNumber : '#authNumber'
            , authNumber2 : '#authNumber2'
            , partnerPopupBtn : '#partnerPopupBtn'
            , partnerSearchBtn : '#partnerSearchBtn'
            , partnerSetBtn : '#partnerSetBtn'
            , authEmlArea : '#auth_eml'
            , authFlArea : '#auth_fl'
            , authFlOptionArea : '#auth_fl_option'
            , authEmlFlArea : '#auth_eml_fl'
            , file01Url : '#file01Url'
            , file01No : '#file01No'
            , file02Url : '#file02Url'
            , file02No : '#file02No'
            , file03Url : '#file03Url'
            , file03No : '#file03No'
            , file04Url : '#file04Url'
            , file04No : '#file04No'
            , recommendNo : '#recommendNo'
            , recommendArea : '#recommend_area'
        },
        init: function() {
            this.el.$container = $(this.selector.container).first();
            this.el.$partnerRegBtn = this.el.$container.find(this.selector.partnerRegBtn);
            this.el.$sendAuthNumberBtn = this.el.$container.find(this.selector.sendAuthNumberBtn);
            this.el.$confirmAuthBtn = this.el.$container.find(this.selector.confirmAuthBtn);
            this.el.$partnerNamePop = this.el.$container.find(this.selector.partnerNamePop);
            this.el.$partnerName = this.el.$container.find(this.selector.partnerName);
            this.el.$empName = this.el.$container.find(this.selector.empName);
            this.el.$email = this.el.$container.find(this.selector.email);
            this.el.$emailDomain = this.el.$container.find(this.selector.emailDomain);
            this.el.$emailInput = this.el.$container.find(this.selector.emailInput);
            this.el.$countDown = this.el.$container.find(this.selector.countDown);
            this.el.$authNumberArea = this.el.$container.find(this.selector.authNumberArea);
            this.el.$authCompleteArea = this.el.$container.find(this.selector.authCompleteArea);
            this.el.$email2 = this.el.$container.find(this.selector.email2);
            this.el.$emailDomain2 = this.el.$container.find(this.selector.emailDomain2);
            this.el.$emailInput2 = this.el.$container.find(this.selector.emailInput2);
            this.el.$countDown2 = this.el.$container.find(this.selector.countDown2);
            this.el.$authNumberArea2 = this.el.$container.find(this.selector.authNumberArea2);
            this.el.$authCompleteArea2 = this.el.$container.find(this.selector.authCompleteArea2);
            this.el.$bulletList = this.el.$container.find(this.selector.bulletList);
            this.el.$partnerAgreement = this.el.$container.find(this.selector.partnerAgreement);
            this.el.$purchasePledge = this.el.$container.find(this.selector.purchasePledge);
            this.el.$purchasePledge_popup = this.el.$container.find(this.selector.purchasePledge_popup);
            this.el.$purchaseAgreeBtn = this.el.$container.find(this.selector.purchaseAgreeBtn);
            this.el.$personalInfoAgree = this.el.$container.find(this.selector.personalInfoAgree);
            this.el.$personalInfoAgree_popup = this.el.$container.find(this.selector.personalInfoAgree_popup);
            this.el.$personalInfoAgreeBtn = this.el.$container.find(this.selector.personalInfoAgreeBtn);
            this.el.$reSendAuthNumber = this.el.$container.find(this.selector.reSendAuthNumber);
            this.el.$authNumber = this.el.$container.find(this.selector.authNumber);
            this.el.$authNumber2 = this.el.$container.find(this.selector.authNumber2);
            this.el.$partnerPopupBtn = this.el.$container.find(this.selector.partnerPopupBtn);
            this.el.$partnerSearchBtn = this.el.$container.find(this.selector.partnerSearchBtn);
            this.el.$partnerSetBtn = this.el.$container.find(this.selector.partnerSetBtn);
            this.data.partnerGrp = this.el.$partnerSearchBtn.data('partner_grp');
            this.data.reCertifyYn = this.el.$partnerSearchBtn.data('recertify_yn');
            this.el.$authEmlArea = this.el.$container.find(this.selector.authEmlArea);
            this.el.$authFlArea = this.el.$container.find(this.selector.authFlArea);
            this.el.$authFlOptionArea = this.el.$container.find(this.selector.authFlOptionArea);
            this.el.$authEmlFlArea = this.el.$container.find(this.selector.authEmlFlArea);
            this.el.$file01Url = this.el.$container.find(this.selector.file01Url);
            this.el.$file01No = this.el.$container.find(this.selector.file01No);
            this.el.$file02Url = this.el.$container.find(this.selector.file02Url);
            this.el.$file02No = this.el.$container.find(this.selector.file02No);
            this.el.$file03Url = this.el.$container.find(this.selector.file03Url);
            this.el.$file03No = this.el.$container.find(this.selector.file03No);
            this.el.$file04Url = this.el.$container.find(this.selector.file04Url);
            this.el.$file04No = this.el.$container.find(this.selector.file04No);
            this.el.$recommendNo = this.el.$container.find(this.selector.recommendNo);
            this.el.$recommendConfirmBtn = this.el.$container.find(this.selector.recommendConfirmBtn);
            this.el.$recommendArea = this.el.$container.find(this.selector.recommendArea);
            partnerReg.bindEvent();
        },

        // 이벤트 바인딩
        bindEvent: function() {
            // 회사명 검색 (팝업)
            this.el.$partnerSearchBtn.on('click', function(e) {
                if (partnerReg.el.$partnerNamePop.val().length < 2) {
                    lgkorUI.alert("", { title: "최소 2자 이상 입력해 주세요.",  ok: function () {} }, partnerReg.el.$partnerNamePop);
                    return;
                }
                partnerReg.searchPartnerList();
            });

            // 회사명 검색 엔터 호출
            this.el.$partnerNamePop.keydown(function(key) {
                if (key.keyCode == 13) {
                    key.preventDefault();
                    partnerReg.el.$partnerSearchBtn.trigger('click');
                }
            });

            // 인증 번호 받기 버튼 클릭
            this.el.$sendAuthNumberBtn.on('click', function(e) {
                var authType = partnerReg.data.authType;
                if ( vcui.isEmpty(partnerReg.el.$partnerName.val()) || vcui.isEmpty(partnerReg.data.partnerCode) ) {
                    lgkorUI.alert("", { title: "회사를 선택해 주세요.", ok: function () {} }, partnerReg.el.$partnerPopupBtn);
                    return;
                }
                if(authType == "EML"){
                    if ( vcui.isEmpty(partnerReg.el.$email.val()) || vcui.isEmpty(partnerReg.el.$emailDomain.val()) ) {
                        lgkorUI.alert("", { title: "이메일을 입력해 주세요.", ok: function () {} }, partnerReg.el.$email);
                        return;
                    }
                }else{
                    if ( vcui.isEmpty(partnerReg.el.$email2.val()) || vcui.isEmpty(partnerReg.el.$emailDomain2.val()) ) {
                        lgkorUI.alert("", { title: "이메일을 입력해 주세요.", ok: function () {} }, partnerReg.el.$email);
                        return;
                    }
                }
                partnerReg.sendPartnerAuthMail();
            });

            // 인증 번호 확인 버튼 클릭
            this.el.$confirmAuthBtn.on('click', function(e) {
                var authType = partnerReg.data.authType;
                if (authType=="EML" && vcui.isEmpty(partnerReg.el.$authNumber.val()) ) {
                    lgkorUI.alert("", { title: "인증번호를 입력해주세요.", ok: function () {} }, partnerReg.el.$authNumber);
                    return;
                }
                if (authType=="EML_FL" && partnerReg.data.subAuthType =="EML" && vcui.isEmpty(partnerReg.el.$authNumber2.val())){
                    lgkorUI.alert("", { title: "인증번호를 입력해주세요.", ok: function () {} }, partnerReg.el.$authNumber);
                    return;
                }

                if ( partnerReg.data.timerSeconds < 0 ) {
                    lgkorUI.alert("", { title: "인증 시간이 초과되었습니다.<br>인증번호 재전송 버튼을 선택해주세요.", ok: function () {} });
                    return;
                }
                partnerReg.confirmPartnerAuth();
            });

            // 재전송 버튼 클릭
            this.el.$reSendAuthNumber.on('click', function(e) {
                var authType = partnerReg.data.authType;
                if (partnerReg.data.reSendPartnerAuthMail != 'Y') {
                    // 인증시간 3분 지난후 재전송
                    if (partnerReg.el.$reSendAuthNumber.hasClass("btn-disabled")) {
                        return;
                    }

                    if ( vcui.isEmpty(partnerReg.el.$partnerName.val()) || vcui.isEmpty(partnerReg.data.partnerCode) ) {
                        lgkorUI.alert("", { title: "회사를 선택해 주세요.", ok: function () {} }, partnerReg.el.$partnerPopupBtn);
                        return;
                    }

                    if(authType == "EML"){
                        if ( vcui.isEmpty(partnerReg.el.$email.val()) || vcui.isEmpty(partnerReg.el.$emailDomain.val()) ) {
                            lgkorUI.alert("", { title: "이메일을 입력해 주세요.", ok: function () {} }, partnerReg.el.$email);
                            return;
                        }
                    }else{
                        if ( vcui.isEmpty(partnerReg.el.$email2.val()) || vcui.isEmpty(partnerReg.el.$emailDomain2.val()) ) {
                            lgkorUI.alert("", { title: "이메일을 입력해 주세요.", ok: function () {} }, partnerReg.el.$email);
                            return;
                        }
                    }

                    partnerReg.data.reSendPartnerAuthMail = 'Y';
                    partnerReg.sendPartnerAuthMail();
                }
            });

            // 추천인 코드 확인
            this.el.$recommendConfirmBtn.on('click', function(e) {
                if (vcui.isEmpty(partnerReg.el.$recommendNo.val())) {
                    lgkorUI.alert("", { title: "추천 코드를 입력해주세요.", ok: function () {} });
                }else{
                    var sendUrl = partnerReg.apiUrl.recommendValid;

                    var requestData = {
                        rcmndCode : partnerReg.el.$recommendNo.val(),
                        partnerType : partnerReg.data.partnerGrp,
                        partnerCd : partnerReg.data.partnerCode
                    }
                    lgkorUI.showLoading();
                    lgkorUI.requestAjaxDataPost(sendUrl, requestData, function(result){
                        if ("000" == result.data[0].resultCode) {
                            var data = result.data[0].data;

                            if(data.recommendType == 'PARTNER'){
                                lgkorUI.confirm("", {
                                   title: data.partnerNm + "<br>추천 코드를 등록하시겠습니까",
                                   ok: function () {
                                        partnerReg.data.recommendAuth='Y';
                                   },
                                   cancel: function(){
                                        partnerReg.el.$recommendNo.val('');
                                        partnerReg.data.recommendAuth='N';
                                   }
                                });
                            }else{
                                lgkorUI.alert("", {
                                    title: "정상적인 추천인 코드입니다.",
                                    ok: function () {
                                        partnerReg.data.recommendAuth='Y';
                                    }
                                });
                            }
                        }else{
                            if(result.data[0].resultCode == "API_EMP_013") {
                                lgkorUI.alert("", { title: "추천 코드가 올바르지 않습니다.", ok: function () {} });
                            }else if(result.data[0].resultCode == "API_EMP_015"){
								lgkorUI.alert("", { title: "소속 회사의 추천 코드는 입력하실 수 없습니다.", ok: function () {} });
							}
                            partnerReg.data.recommendAuth='N';
                        }
                        lgkorUI.hideLoading();
                    });
                }
            });

            // 구매서약서 팝업 호출
            this.el.$purchasePledge.on('click', function(e) {
                if (partnerReg.el.$purchasePledge.is(':checked')) {
                    partnerReg.el.$purchasePledge.prop("checked", false);
                    partnerReg.el.$purchasePledge_popup.vcModal();
                }
            });

            // 구매서약서 동의 버튼 클릭시
            this.el.$purchaseAgreeBtn.on('click', function(e) {
                partnerReg.el.$purchasePledge.prop("checked", true);
                partnerReg.el.$purchasePledge_popup.vcModal('close');
            });

            // 개인정보수집 이용동의 약관 팝업 호출
            this.el.$personalInfoAgree.on('click', function(e) {
                if (partnerReg.el.$personalInfoAgree.is(':checked')) {
                    partnerReg.el.$personalInfoAgree.prop("checked", false);

                    if (partnerReg.data.setPartnerPrivacy == 'N') {
                        partnerReg.getPartnerPrivacy();
                    } else {
                        partnerReg.el.$personalInfoAgree_popup.vcModal();
                    }
                }
            });
            partnerReg.el.$personalInfoAgree_popup.on('modalhide', function(){ // BTOCSITE-77491 웹접근성
                setTimeout(function(){
                    partnerReg.el.$personalInfoAgree.focus();
                }, 300);
            });

            // 개인정보수집 이용동의 약관 동의 버튼 클릭시
            this.el.$personalInfoAgreeBtn.on('click', function(e) {
                partnerReg.el.$personalInfoAgree.prop("checked", true);
                partnerReg.el.$personalInfoAgree_popup.vcModal('close');
                partnerReg.data.prsinClctnYn = 'Y';
            });

            $('input[name=auth-type]').on('change',function(){
                partnerReg.data.subAuthType= $('input[name=auth-type]:checked').val();
            });

            //재직증명서 / 사원증 및 증빙서류 셋팅
            $('#file01').on('change',function(){
               partnerReg.fileSetting("file01");
            });
            $('#file02').on('change',function(){
                partnerReg.fileSetting("file02");
            });
            $('#file03').on('change',function(){
                partnerReg.fileSetting("file03");
            });
            $('#file04').on('change',function(){
                partnerReg.fileSetting("file04");
            });


            // 임직원 등록 버튼 클릭
            this.el.$partnerRegBtn.on('click', function(e) {
                if ( vcui.isEmpty(partnerReg.el.$partnerName.val()) || vcui.isEmpty(partnerReg.data.partnerCode) ) {
                    lgkorUI.alert("", { title: "회사를 선택해 주세요.", ok: function () {} }, partnerReg.el.$partnerPopupBtn);
                    return;
                }

                if ( partnerReg.data.partnerAuthYn == 'N' ){
                    if(partnerReg.data.authType=='EML'){
                        lgkorUI.alert("", { title: "이메일 인증하신 후 임직원 등록이 가능합니다.", ok: function () {} });
                        return;
                    }else if(partnerReg.data.authType=='FL'){
                        if( $('#file01')[0].files.length == 0 ){
                            lgkorUI.alert("", { title: "필수 증빙서류를 첨부해주세요.<br> 10M이하 이미지 또는 PDF파일만<br>등록 가능합니다.(JPG,GIF,BMP,PDF)", ok: function () {} });
                            return;
                        }else if(partnerReg.fileCheck($('#file01')[0])){
                            lgkorUI.alert("", { title: "파일 용량 또는 확장자를 확인해주세요.", ok: function () {} });
                            return;
                        }
                        if( $('#file02')[0].files.length != 0 && partnerReg.fileCheck($('#file02')[0])){
                            lgkorUI.alert("", { title: "파일 용량 또는 확장자를 확인해주세요.", ok: function () {} });
                            return;
                        }
                    }else{
                        if(partnerReg.data.subAuthType =="EML"){
                            lgkorUI.alert("", { title: "이메일 인증하신 후 임직원 등록이 가능합니다.", ok: function () {} });
                            return;
                        }else if(partnerReg.data.subAuthType =="FL"){
                            if( $('#file03')[0].files.length == 0 ){
                                lgkorUI.alert("", { title: "필수 증빙서류를 첨부해주세요.<br> 10M이하 이미지 또는 PDF파일만<br>등록 가능합니다.(JPG,GIF,BMP,PDF)", ok: function () {} });
                                return;
                            }else if(partnerReg.fileCheck($('#file03')[0])){
                                lgkorUI.alert("", { title: "파일 용량 또는 확장자를 확인해주세요.", ok: function () {} });
                                return;
                            }
                            if( $('#file04')[0].files.length != 0 && partnerReg.fileCheck($('#file04')[0])){
                                lgkorUI.alert("", { title: "파일 용량 또는 확장자를 확인해주세요.", ok: function () {} });
                                return;
                            }
                        }
                    }
                }

                if(!vcui.isEmpty(partnerReg.el.$recommendNo.val()) && partnerReg.data.recommendAuth != 'Y'){
                    lgkorUI.alert("", { title: "추천 코드가 올바르지 않습니다.", ok: function () {} });
                    return;
                }
                if ( !partnerReg.el.$partnerAgreement.is(':checked') ) {
                    lgkorUI.alert("", { title: "임직원 등록에 동의해주세요.", ok: function () {} });
                    return;
                }

                if ( !partnerReg.el.$personalInfoAgree.is(':checked') ) {
                    lgkorUI.alert("", { title: "개인정보 수집 이용동의에 동의해주세요.", ok: function () {} });
                    return;
                }

                if (partnerReg.data.prsinClctnYn == 'N') {
                    lgkorUI.alert("", { title: "개인정보 수집 이용동의 약관 확인 및 <br>동의 후 등록 가능합니다.", ok: function () {} });
                    partnerReg.el.$personalInfoAgree.prop("checked", false);
                    return;
                }

                if ( !partnerReg.el.$purchasePledge.is(':checked') ) {
                    lgkorUI.alert("", { title: "임직원 구매 서약서에 동의해주세요.", ok: function () {} });
                    return;
                }

                if(partnerReg.data.authType=='EML'){
                    partnerReg.registerPartner(partnerReg.data.authType);
                }else if(partnerReg.data.authType=='FL'){
                    var file1Flag = false;
                    var file2Flag = true;

                    var fileInput01 = $('#file01')[0];
                    file1Flag = partnerReg.fileUpload(fileInput01,1);

                    var fileInput02 = $('#file02')[0];
                    if(!vcui.isEmpty(fileInput02.files[0])){
                        file2Flag = partnerReg.fileUpload(fileInput02,2);
                    }
                    if(file1Flag&&file2Flag){
                       partnerReg.registerPartner(partnerReg.data.authType);
                    }
                }else{
                    if(partnerReg.data.subAuthType=="EML"){
                        partnerReg.registerPartner(partnerReg.data.authType);
                    }else if(partnerReg.data.subAuthType=="FL"){
                        var file3Flag = false;
                        var file4Flag = true;

                        var fileInput03 = $('#file03')[0];
                        file3Flag = partnerReg.fileUpload(fileInput03,3);

                        var fileInput04 = $('#file04')[0];
                        if(!vcui.isEmpty(fileInput04.files[0])){
                            file4Flag = partnerReg.fileUpload(fileInput04,4);
                        }
                        if(file3Flag&&file4Flag){
                           partnerReg.registerPartner(partnerReg.data.authType);
                        }
                    }
                }
            });


            // 회사명 팝업 내 확인 버튼
            this.el.$partnerSetBtn.on('click', function(e) {
                var partner_cd = $('input[name=rdo1]:checked').data('partner_cd');
                // 선택값 존재 시
                if (partner_cd != undefined) {
                    var authType = '';
                    var proofNm ='';
                    var authTypeText = '';

                    if(partnerReg.data.partnerGrp =="AFF"){
                        authType = "EML";
                    }else{
                        authType = $('input[name=rdo1]:checked').data('auth_type');
                        //화면 노출 분기
                        if(authType=='EML'){
                            partnerReg.el.$authEmlArea.show();
                            partnerReg.el.$authFlArea.hide();
                            partnerReg.el.$authFlOptionArea.hide();
                            partnerReg.el.$authEmlFlArea.hide();
                        }else if(authType=='FL'){
                            proofNm =$('input[name=rdo1]:checked').data('proof_nm');
                            $('#proofTypeNm1').text(proofNm);
                            partnerReg.el.$authFlArea.show();
                            partnerReg.el.$authFlOptionArea.show();
                            partnerReg.el.$authEmlArea.hide();
                            partnerReg.el.$authEmlFlArea.hide();
                        }else{
                            proofNm =$('input[name=rdo1]:checked').data('proof_nm');
                            $('#proofTypeNm2').text(proofNm+" 인증");
                            $('#proofTypeNm3').text(proofNm);
                            partnerReg.el.$authEmlFlArea.show();
                            partnerReg.el.$authEmlArea.hide();
                            partnerReg.el.$authFlArea.hide();
                            partnerReg.el.$authFlOptionArea.hide();

                            //BTOCSITE-74192 : [제휴사복지몰]복지몰 고객(회원) 인증 시 선택 옵션 설명 추가 요청
                            authTypeText =$('input[name=rdo1]:checked').data('auth_type_text');

                            if(authTypeText == "이메일"){
                                partnerReg.el.$authEmlFlArea.find('.ui_radio_visible li:eq(1)').hide();
                                partnerReg.el.$authEmlFlArea.find('.ui_radio_visible li:eq(0)').show();

                                $("#auth-type01").prop("checked", true);
                                partnerReg.data.subAuthType= "EML";

                                partnerReg.el.$authEmlFlArea.find('.auth-certificate').hide();
                                partnerReg.el.$authEmlFlArea.find('.auth-email').show();
                            } else {
                                partnerReg.el.$authEmlFlArea.find('.ui_radio_visible li:eq(0)').hide();
                                partnerReg.el.$authEmlFlArea.find('.ui_radio_visible li:eq(1)').show();

                                $("#auth-type02").prop("checked", true);
                                partnerReg.data.subAuthType= "FL";

                                partnerReg.el.$authEmlFlArea.find('.auth-email').hide();
                                partnerReg.el.$authEmlFlArea.find('.auth-certificate').show();
                            }
                            //BTOCSITE-74192 : [제휴사복지몰]복지몰 고객(회원) 인증 시 선택 옵션 설명 추가 요청

                        }
                        if(partnerReg.data.reCertifyYn == "N"){
                            partnerReg.el.$recommendArea.show();
                        }
                    }

                    // 기존 선택값과 상이한 경우 정보 세팅
                    var email_domain = $('input[name=rdo1]:checked').data('email_domain');
                    var checked_partner_val = partner_cd + '|' + email_domain;

                    if (partnerReg.data.checkedPartner != checked_partner_val) {
                        partnerReg.data.checkedPartner = checked_partner_val;
                        partnerReg.data.partnerCode = partner_cd;
                        partnerReg.data.authType = authType;
                        partnerReg.el.$partnerName.val($('input[name=rdo1]:checked').data('partner_nm'));

                        if (email_domain != '' && email_domain != null) {
                            if(authType=="EML"){
                                //BTOCSITE-74192 : [제휴사복지몰]복지몰 고객(회원) 인증 시 선택 옵션 설명 추가 요청
                                if(email_domain == "(개인이메일)"){
                                    partnerReg.el.$emailDomain.val('');
                                    partnerReg.el.$emailDomain.prop("readonly", false);
                                } else{
                                    partnerReg.el.$emailDomain.val(email_domain);
                                    partnerReg.el.$emailDomain.prop("readonly", true);
                                }
                            } else {
                                //BTOCSITE-74192 : [제휴사복지몰]복지몰 고객(회원) 인증 시 선택 옵션 설명 추가 요청
                                if(email_domain == "(개인이메일)" || email_domain == "-"){
                                    partnerReg.el.$emailDomain2.val('');
                                    partnerReg.el.$emailDomain2.prop("readonly", false);
                                } else {
                                    partnerReg.el.$emailDomain2.val(email_domain);
                                    partnerReg.el.$emailDomain2.prop("readonly", true);
                                }
                            }
                        } else {
                            partnerReg.el.$emailDomain.val('');
                            partnerReg.el.$emailDomain.prop("readonly", false);
                            partnerReg.el.$emailDomain2.val('');
                            partnerReg.el.$emailDomain2.prop("readonly", false);
                        }
                        partnerReg.el.$email.val('');
                        partnerReg.el.$email.prop("readonly", false);
                        partnerReg.el.$email2.val('');
                        partnerReg.el.$email2.prop("readonly", false);

                        //선택 회사 바뀔 때 추천인 코드 리셋
                        partnerReg.el.$recommendNo.val('');

                        //선택 회사가 바뀔 때 마다 재직증명서 초기화
                        $('#file01Nm').val('');
                        $('#file01').val('');
                        $('#file02Nm').val('');
                        $('#file02').val('');
                    }
                } else {
                    lgkorUI.alert("", { title: "회사를 선택해주세요.", ok: function () {} }, partnerReg.el.$partnerPopupBtn);

                    // 미선택 시 초기화
                    partnerReg.data.checkedPartner = '';
                    partnerReg.data.partnerCode = '';
                    partnerReg.data.authType = '';
                    partnerReg.el.$partnerName.val('');
                    partnerReg.el.$email.val('');
                    partnerReg.el.$emailDomain.val('');
                    partnerReg.el.$email.prop("readonly", true);
                    partnerReg.el.$emailDomain.prop("readonly", true);
                    partnerReg.el.$email2.val('');
                    partnerReg.el.$emailDomain2.val('');
                    partnerReg.el.$email2.prop("readonly", true);
                    partnerReg.el.$emailDomain2.prop("readonly", true);

                    //선택 회사가 바뀔 때 마다 재직증명서 초기화
                    $('#file01Nm').val('');
                    $('#file01').val('');
                    $('#file02Nm').val('');
                    $('#file02').val('');
                    $('#file03Nm').val('');
                    $('#file03').val('');
                    $('#file04Nm').val('');
                    $('#file04').val('');
                }

            });

            // 이메일 입력
            this.el.$emailInput.on('keypress', function (e) {
                var re = /[A-Z0-9a-z._\-+]/.test(e.key);
                if (!re) {
                    return false;
                }
            });

            //이메일2 입력
            // 이메일 입력
            this.el.$emailInput2.on('keypress', function (e) {
                var re = /[A-Z0-9a-z._\-+]/.test(e.key);
                if (!re) {
                    return false;
                }
            });
        },

        // 회사명 검색
        searchPartnerList : function() {
            var sendUrl = partnerReg.apiUrl.searchPartnerList;

            var requestData = {
                partnerNm : partnerReg.el.$partnerNamePop.val(),
                partnerGrp : partnerReg.data.partnerGrp
            }
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(sendUrl, requestData, function(result){
                var data = result.data[0];

                if (Object.keys(data.partnerList).length > 0) {
                    $('#disp-partner-list').html(vcui.template(partnerListTmpl, data));
                    $('.pop-footer').show();
                } else {
                    $('#disp-partner-list').html(vcui.template(noDataTmpl));
                    $('.pop-footer').hide();
                }
                lgkorUI.hideLoading();
            });
        },

        // 개인정보 수집 및 이용 동의서 조회
        getPartnerPrivacy : function() {
            var sendUrl = partnerReg.apiUrl.getPartnerPrivacy;

            var requestData = {
                partnerType : partnerReg.data.partnerGrp
            }
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(sendUrl, requestData, function(result){
                var data = result.data[0];

                if (result.status == "success" && data.cont != null && data.cont != 'null' && data.cont != '') {
                    $('#partnerPrivacyTit').html(data.tit);
                    $('#partnerPrivacyCont').html(data.cont);

                    lgkorUI.hideLoading();
                    partnerReg.data.setPartnerPrivacy = 'Y';
                    partnerReg.el.$personalInfoAgree_popup.vcModal();
                } else {
                    lgkorUI.alert("", { title: "처리 중 오류가 발생했습니다.<br>잠시 후 다시 시도해 주세요.", ok: function () {
                            location.href = partnerReg.el.$partnerRegBtn.data('url_string') + '/registration-info';
                    } });
                }
            });
        },

        // 카운트다운
        setCountDown : function() {
            var authType = partnerReg.data.authType;

            clearInterval(partnerReg.data.countInterval);
            partnerReg.data.countInterval = setInterval(function () {
                var min = parseInt((partnerReg.data.timerSeconds)/60);
                var sec = partnerReg.data.timerSeconds % 60;
                if (sec < 10) { sec = "0" + sec; }

                if (min == "00" && sec == "00") {
                    partnerReg.el.$reSendAuthNumber.removeClass("btn-disabled").removeClass("tabindex");
                }
                if(authType=="EML"){
                    partnerReg.el.$countDown.html("0" + min + ":" + sec);
                }else{
                    partnerReg.el.$countDown2.html("0" + min + ":" + sec);
                }
                partnerReg.data.timerSeconds--;
                if (partnerReg.data.timerSeconds < 0) {
                    clearInterval(partnerReg.data.countInterval);
                }
            }, 1000);
        },

        // 인증 메일 발송
        sendPartnerAuthMail : function() {
            var sendUrl = partnerReg.apiUrl.sendPartnerAuthMail;

            var authType = partnerReg.data.authType;
            var userEmail = partnerReg.el.$email.val().replace(/ /gi,"");
            var emailDomain = partnerReg.el.$emailDomain.val().replace(/ /gi,"");

            if(authType == "EML_FL" && partnerReg.data.subAuthType =="EML"){
                userEmail = partnerReg.el.$email2.val().replace(/ /gi,"");
                emailDomain = partnerReg.el.$emailDomain2.val().replace(/ /gi,"");
            }

            partnerReg.data.email = userEmail + '@' + emailDomain;

            var pattern =  /^([A-Z0-9a-z._\-+]+)@([A-Z0-9a-z_\-+]+)(\.[A-Z0-9a-z_\-+]+){1,3}$/;

            if (!pattern.test(partnerReg.data.email)) {
                lgkorUI.alert("", { title: "올바른 이메일을 입력해주세요.", ok: function () {} }, partnerReg.el.$email);
                return;
            }

            var requestData = {
                partnerCd : partnerReg.data.partnerCode,
                empNm : partnerReg.el.$empName.val(),
                eml : partnerReg.data.email
            }
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(sendUrl, requestData, function(result){

                if ("S" == result.data[0].resultCode) {
                    if(authType=="EML"){
                        partnerReg.el.$bulletList.hide();
                        partnerReg.el.$authNumberArea.show();
                    }else{
                        partnerReg.el.$authNumberArea2.show();
                    }
                    partnerReg.el.$sendAuthNumberBtn.hide();
                    partnerReg.el.$reSendAuthNumber.addClass("btn-disabled").attr("tabindex","-1");
                    partnerReg.el.$partnerPopupBtn.attr("style", "display:none;");

                    if (partnerReg.data.reSendPartnerAuthMail == 'Y') {
                        lgkorUI.alert("", { title: "이메일로 인증번호가 재전송되었습니다.", ok: function () {} });
                    }
                    partnerReg.data.timerSeconds = 180;
                    partnerReg.setCountDown();

                    if(authType=="EML"){
                        partnerReg.el.$email.prop("readonly", true);
                        partnerReg.el.$emailDomain.prop("readonly", true);
                    }else{
                        partnerReg.el.$email2.prop("readonly", true);
                        partnerReg.el.$emailDomain2.prop("readonly", true);
                    }
                } else {
                    partnerReg.el.$reSendAuthNumber.removeClass("btn-disabled").removeClass("tabindex");
                    // 에러코드에 따른 메세지 노출 처리
                    if (result.data[0].errorCode == "API_EMP_001") {
                        if (partnerReg.data.partnerGrp == "AFF") {
                            lgkorUI.alert("입력하신 정보와 일치하는<br>임직원 정보를 찾을 수 없습니다.<br>" +
                                "관련 문의는 1544-9665로 해주세요."); // 전자 임직원몰 / 계열사 임직원몰  // [BTOCSITE-58706] 고객센터 전화번호 변경 1544-7777 -> 1544-9665
                        } else { // AFC
                            lgkorUI.alert("입력하신 정보와 일치하는<br>임직원 정보를 찾을 수 없습니다.<br>" +
                                "관련 문의는 1544-8777로 해주세요."); // 복지몰 / 사업자몰
                        }
                    } else if (result.data[0].errorCode == "API_VLD_014") {
                        lgkorUI.confirm('', {
                            title:partnerReg.el.$partnerRegBtn.data('disp_mall_name') + ' 혜택을 받기 위해 <br> LGE.COM 로그인이 필요합니다.<br>이동하시겠습니까?',
                            okBtnName: '네',
                            cancelBtnName: '아니오',
                            ok: function() {
                                location.href = partnerReg.el.$partnerRegBtn.data('login_url');
                            },
                            cancel: function() {
                                location.href = partnerReg.el.$partnerRegBtn.data('url_string') + '/registration-info';
                            }
                        });
                    } else {
                        lgkorUI.alert("", { title: result.data[0].resultMsg, ok: function () {} });
                    }
                }
                partnerReg.data.reSendPartnerAuthMail = 'N';
                lgkorUI.hideLoading();
            });
        },

        // 인증 번호 확인
        confirmPartnerAuth : function() {
            var sendUrl = partnerReg.apiUrl.confirmPartnerAuth;
            var authType = partnerReg.data.authType;
            var authNo = "";
            if(authType=="EML"){
                authNo=partnerReg.el.$authNumber.val();
            }else{
                authNo=partnerReg.el.$authNumber2.val();
            }

            var requestData = {
                partnerCd : partnerReg.data.partnerCode,
                eml : partnerReg.data.email,
                empNm : partnerReg.el.$empName.val(),
                ctfNo : authNo
            }
            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(sendUrl, requestData, function(result){
                if ("S" == result.data[0].resultCode) {
                    partnerReg.data.partnerAuthYn = 'Y';
                    if(authType=="EML"){
                        partnerReg.el.$authNumberArea.hide();
                        partnerReg.el.$authCompleteArea.show();
                        partnerReg.el.$email.prop("readonly", true);
                    }else{
                        partnerReg.el.$authNumberArea2.hide();
                        partnerReg.el.$authCompleteArea2.show();
                        partnerReg.el.$email2.prop("readonly", true);
                    }
                } else {
                    // 에러코드에 따른 메세지 노출 처리
                    if (result.data[0].errorCode == "API_EMP_004") {
                        lgkorUI.alert("", { title: "인증번호가 올바르지 않습니다.<br>다시 입력해주세요.", ok: function () {} }, partnerReg.el.$authNumber);
                    } else if (result.data[0].errorCode == "API_VLD_014") {
                        lgkorUI.confirm('', {
                            title:partnerReg.el.$partnerRegBtn.data('disp_mall_name') + ' 혜택을 받기 위해 <br> LGE.COM 로그인이 필요합니다.<br>이동하시겠습니까?',
                            okBtnName: '네',
                            cancelBtnName: '아니오',
                            ok: function() {
                                location.href = partnerReg.el.$partnerRegBtn.data('login_url');
                            },
                            cancel: function() {
                                location.href = partnerReg.el.$partnerRegBtn.data('url_string') + '/registration-info';
                            }
                        });
                    } else {
                        lgkorUI.alert("", { title: result.data[0].resultMsg, ok: function () {} });
                    }
                }
                lgkorUI.hideLoading();
            });
        },

        //재직증명서 파일 업로드
        fileUpload : function(fileInput,fileNo) {
            var returnFlag = false;
            var formData = new FormData();
            formData.append('file', fileInput.files[0]);

            var partnerType = partnerReg.data.partnerGrp;
            var fileUploadUrl ="";
            if(partnerType=="AFF"){
                fileUploadUrl =partnerReg.apiUrl.affFileUploadUrl;
            }else if(partnerType =="AFC"){
                fileUploadUrl =partnerReg.apiUrl.afcFileUploadUrl;
            }

            $.ajax({
                type: "POST",
                enctype: 'multipart/form-data',
                url : fileUploadUrl,
                data : formData,
                async : false,
                //dataType:"json",
                processData : false,	// data 파라미터 강제 string 변환 방지!!
                contentType : false,	// application/x-www-form-urlencoded; 방지!!
                cache : false,
                success : function (result) {
                    if("000" == result.resultCode){
                        returnFlag = true;
                        $('#file0'+fileNo+'Url').val(result.data.flUrl);
                        $('#file0'+fileNo+'No').val(result.data.flNo);
                    }else{
                        if("API_VLD_054"==result.resultCode){
                            lgkorUI.alert("", { title: "필수 증빙서류를 첨부해주세요.<br> 10M이하 이미지 또는 PDF파일만<br>등록 가능합니다.(JPG,GIF,BMP,PDF)", ok: function () {} });
                        }else{
                            lgkorUI.alert("", { title: result.resultMsg, ok: function () {} });
                        }
                    }
                },
                error: function (e) {
                    lgkorUI.alert("", { title: "증빙자료 업로드 중 오류가 발생했습니다.", ok: function () {} });
                }
            });
            return returnFlag;
        },

        // 임직원 등록
        registerPartner : function(authType) {
            var sendUrl = partnerReg.apiUrl.registerPartner;
            var requestData = {
                authType : authType,
                partnerCd : partnerReg.data.partnerCode,
                eml : partnerReg.data.email,
                empNm : partnerReg.el.$empName.val(),
                ctfNo : partnerReg.el.$authNumber.val(),
                rcmndCode : partnerReg.el.$recommendNo.val(),
                prsinClctnYn : partnerReg.data.prsinClctnYn
            }
            if("EML_FL"==authType){
                requestData.authType = partnerReg.data.subAuthType;
                if(partnerReg.data.subAuthType =="EML"){
                    requestData.ctfNo = partnerReg.el.$authNumber2.val();
                }else if(partnerReg.data.subAuthType =="FL"){
                    requestData.proofFlNo = partnerReg.el.$file03No.val();
                    requestData.proofFlUrl = partnerReg.el.$file03Url.val();
                    requestData.proofFl2No = partnerReg.el.$file04No.val();
                    requestData.proofFl2Url = partnerReg.el.$file04Url.val();
                    requestData.eml = "test@test.test";
                    delete requestData.ctfNo;
                }
            }
            if("FL"==authType){
                requestData.proofFlNo = partnerReg.el.$file01No.val();
                requestData.proofFlUrl = partnerReg.el.$file01Url.val();
                requestData.proofFl2No = partnerReg.el.$file02No.val();
                requestData.proofFl2Url = partnerReg.el.$file02Url.val();
                requestData.eml = "test@test.test";
                delete requestData.ctfNo;
            }

            lgkorUI.showLoading();

            lgkorUI.requestAjaxDataPost(sendUrl, requestData, function(result){
                if ("S" == result.data[0].resultCode) {
                    if ("" != result.data[0].lifeCareRedirectUrl) {
                        lgkorUI.alert("", { title: "임직원 등록이 완료되었습니다.", ok: function () {
                                location.href = result.data[0].lifeCareRedirectUrl;
                            } });
                    } else {
                        location.href = partnerReg.el.$partnerRegBtn.data('url_string') + '/registration-complete';
                    }
                } else if (result.data[0].errorCode == "API_VLD_014") {
                    lgkorUI.confirm('', {
                        title:partnerReg.el.$partnerRegBtn.data('disp_mall_name') + ' 혜택을 받기 위해 <br> LGE.COM 로그인이 필요합니다.<br>이동하시겠습니까?',
                        okBtnName: '네',
                        cancelBtnName: '아니오',
                        ok: function() {
                            location.href = partnerReg.el.$partnerRegBtn.data('login_url');
                        },
                        cancel: function() {
                            location.href = partnerReg.el.$partnerRegBtn.data('url_string') + '/registration-info';
                        }
                    });
                } else if (result.data[0].errorCode == "API_VLD_039") {
                    lgkorUI.alert("", { title: "개인정보 수집 이용동의 약관 확인 및 <br>동의 후 등록 가능합니다.", ok: function () {} });
                    partnerReg.el.$personalInfoAgree.prop("checked", false);
                } else {
                    if ("" != result.data[0].lifeCareRedirectUrl) {
                        lgkorUI.alert("", { title: "입력하신 정보와 일치하는 임직원 정보를 찾을 수 없습니다.", ok: function () {
                                location.href = "/";
                            } });
                    } else {
                        lgkorUI.alert("", { title: result.data[0].resultMsg, ok: function () {} });
                    }
                }
                lgkorUI.hideLoading();
            });
        },

        // 파일 사이즈 10M 이하만 가능
        fileCheck : function(param) {
            var mb = 1024 * 1024 //1mb
            var limitSize = mb * 10;
            var uploadSize = param.files[0].size;

            if(limitSize < uploadSize){
                return true;
            }
        },

        fileSetting : function(param){
            var file = $('#'+param);
            var fileInput = file[0];
            if(vcui.isEmpty(fileInput.files[0])){
                $('#'+param+'Nm').val('');
                file.val('');
            }else{
                var fileNm = fileInput.files[0].name;
                var reg = /(.*?)\.(jpg|gif|bmp|pdf)$/;

                if (fileNm != "" && (null == fileNm.match(reg) || false == reg.test(fileNm))) {
                    $('#'+param+'Nm').val('');
                    file.val('');
                }else{
                    $('#'+param+'Nm').val(fileNm);
                }
            }
        }

    };

    $(document).ready(function() {
        partnerReg.init();
        lgkorUI.setEnableAppScrollBottomMenu(false);
        lgkorUI.showAppBottomMenu(false);

        // $(document).on('click', "*[name='rdo1']", function() {
        // 	partnerReg.el.$partnerSetBtn.trigger('click');
        // });
    });

    var noDataTmpl =
        '<div class="no-data">\n'+
        '	<p>조회되는 회사명이 없습니다.</p>\n'+
        '</div>\n';

    //BTOCSITE-74192 : [제휴사복지몰]복지몰 고객(회원) 인증 시 선택 옵션 설명 추가 요청
    var partnerListTmpl =
        '<div class="tbl-layout">\n'+
        '	<div class="thead" aria-hidden="true">\n'+
        '		<span class="th col1">선택</span>\n'+
        '		<span class="th col2">회사명</span>\n'+
        '		<span class="th col3">사업자등록번호</span>\n'+
        '       {{#if partnerList[0].partnerGrp=="AFF"}}'+
        '		<span class="th col4">도메인</span>\n'+
        '       {{#else}}' +
        '		<span class="th col4">인증방식</span>\n'+
        '       {{/if}}'+
        '       {{#if partnerList[0].partnerGrp=="AFC"}}'+
        '		<span class="th col5">도메인</span>\n'+
        '       {{/if}}'+
        '	</div>\n'+
        '	<div class="tbody">\n'+
        '{{#each (item, index) in partnerList}}' +
        '		<div class="row">\n'+
        '			<div class="col-table">\n'+
        '				<div class="col col1">\n'+
        '                   <span class="rdo-wrap">\n'+
        '                       <input type="radio" id="rdo1-{{index+1}}" name="rdo1" data-partner_nm="{{item.partnerNm}}" data-partner_cd="{{item.partnerCd}}" data-email_domain="{{item.emailDomain}}" data-auth_type="{{item.authType}}" data-auth_type_text="{{item.authTypeText}}" data-proof_nm ="{{item.proofTypeNm}}">\n'+
        '                       <label For="rdo1-{{index+1}}"><span class="blind">{{item.partnerNm}}</span></label>\n'+
        '                   </span>\n'+
        '				</div>\n'+
        '				<div class="col col2">\n'+
        '					<em class="mo-only">회사명</em><span>{{item.partnerNm}}</span>\n'+
        '				</div>\n'+
        '				<div class="col col3">\n'+
        '					<em class="mo-only">사업자등록번호</em><span>{{item.dispCorpNo}}</span>\n'+
        '				</div>\n'+
        '				<div class="col col4">\n'+
        '               {{#if item.partnerGrp=="AFF"}}'+
        '					<em class="mo-only">도메인</em><span>{{item.emailDomain}}</span>\n'+
        '               {{#else}}' +
        '					<em class="mo-only">인증방식</em><span>{{item.authTypeText}}</span>\n'+
        '               {{/if}}'+
        '				</div>\n'+
        '               {{#if item.partnerGrp=="AFC"}}'+
        '				<div class="col col5">\n'+
        '					<em class="mo-only">도메인</em><span>{{item.emailDomain}}</span>\n'+
        '				</div>\n'+
        '               {{/if}}'+
        '			</div>\n'+
        '		</div>\n'+
        '{{/each}}'+
        '	</div>\n'+
        '</div>\n'+
        '{{#if partnerList[0].partnerGrp=="AFC"}}'+
        '<div class="notice-wrap">\n'+
        '   <ul class="bullet-list">\n'+
        '        <li class="b-txt">인증 방식이 ‘이메일’일 경우 도메인이 포함된 메일로 인증번호가 전송됩니다.</li>\n'+
        '    </ul>\n'+
        '</div>\n'+
        '{{/if}}';
})();